module.exports = __webpack_public_path__ + "img/24.2b31b0d5.gif";